import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { IoMdAdd } from "react-icons/io";
import { useQuery } from "../../../hooks";
import { getAllAnnouncements, deleteAnnouncement } from "../../../redux/actions";
import { TableContainer, Button } from "../../../UI";
import { columns } from "./tableData";
import ModalContent from "./ModalContent";
import Container from "./style";

const ManageAnnouncement = () => {
  const dispatch = useDispatch();
  const { announcements, authenticatedUserData: { role } } = useSelector((state) => state.dashStats);
  const modal = useQuery().get("modal");
  const history = useHistory();
  const [loaders, setLoaders] = useState([]);
  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(getAllAnnouncements());
  }, [dispatch]);

  const handleEditAnnouncement = (record) => {
    history.push(`${pathname}?modal=edit`, { id: record.id });
  };

  const handleDeleteAnnouncement = async (id) => {
    setLoaders((s) => [...s, id]);
    await dispatch(deleteAnnouncement(id));
    setLoaders((s) => s.filter((item) => item !== id));
  };

  return (
    <>
      {(modal === "add" || modal === "edit") && (
        <ModalContent {...{ action: modal, announcements }} />
      )}
      <Container>
        <header className="component-header">
          <h1>App Home Pop-ups</h1>
          <p style={{ color: "#666", fontSize: "0.9rem", marginTop: "-10px" }}>
            Manage persistent announcements that appear as pop-ups on the mobile app home screen. These follow scheduling (start/end date) rules.
          </p>
          {role === "admin" && (
            <div className="action-group">
              <Button onClick={() => history.push(`${pathname}?modal=add`)}>
                <IoMdAdd />
                Add New
              </Button>
            </div>
          )}
        </header>
        <TableContainer
          {...{
            dataSource: announcements,
            columns: columns({
              handleEditAnnouncement,
              handleDeleteAnnouncement,
              loaders,
              role,
            }),
          }}
        />
      </Container>
    </>
  );
};

export default ManageAnnouncement;
